/**
 * AutoCount Full's lock (docs/billing-autocount-connector-pricing-proposal.md §3.2 and §9 in the SVN
 * repo). A module on the AutoCount connector that the workspace's plan does not cover answers its
 * listing, entry and dashboard reads with HTTP 402:
 *
 *   { error: "connector_full_required", code, connector: "autocount", module, trialAvailable,
 *     isWorkspaceAdmin, message }
 *
 * That is an upsell, not an outage, so the views show FTSConnectorLockCard in place of their red
 * error. Other 402s (the AI credit gate's credits_exhausted, teammateBlocks.js) are not this.
 */
export const CONNECTOR_FULL_REQUIRED = "connector_full_required";

/** The lock a failed read carries ({ connector, module, message, trialAvailable, isWorkspaceAdmin }), or null. */
export function connectorLockFromError(err) {
  const response = err && err.response;
  const data = response && response.data;
  if (!response || response.status !== 402 || !data || typeof data !== "object") return null;
  if (data.error !== CONNECTOR_FULL_REQUIRED && data.code !== CONNECTOR_FULL_REQUIRED) return null;
  return {
    connector: data.connector || "autocount",
    module: data.module || "",
    message: data.message || "",
    trialAvailable: Boolean(data.trialAvailable),
    isWorkspaceAdmin: Boolean(data.isWorkspaceAdmin),
  };
}

export default { CONNECTOR_FULL_REQUIRED, connectorLockFromError };
